import React from 'react'
import { useSelector } from 'react-redux'

import views from '../../configuration/views'

import CalendarContainer from './calendar/CalendarContainer'
import GridContainer from './grid/GridContainer'

const Views = () => {
  const currentView = useSelector((state) => state.filtersData.view)

  switch (currentView) {
    case views.monthly:
      return <CalendarContainer />
    case views.daily:
      return <GridContainer view={currentView} />
    case views.weekly:
      return <GridContainer view={currentView} />
    default:
      return <CalendarContainer />
  }
}

export default Views
